import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductCategories() {
  const categories = [{
    title: 'Asset labels',
    description: 'Barcode, QR code, and serial number labels for fixed asset tracking.',
    image: 'https://cdn.magicpatterns.com/uploads/oGywBGEenwNAQNUxQgJ7WH/avery_0.jpg',
    size: 'large',
    href: '/products/asset-labels'
  }, {
    title: 'Safety signage',
    description: 'ISO and BS compliant hazard warnings and safety notices.',
    image: 'https://cdn.magicpatterns.com/uploads/stKpBKCKVgJuHFqzdjUtts/nosco.jpg',
    size: 'normal',
    href: '/products/safety-signage'
  }, {
    title: 'Metal nameplates',
    description: 'Anodised aluminium and stainless steel equipment plates.',
    image: 'https://cdn.magicpatterns.com/uploads/tJSKDWvfkQrhPVgAKo8zjT/nameplates.jpg',
    size: 'normal',
    href: '/products/nameplates'
  }, {
    title: 'Tamper evident & security labels',
    description: 'Void labels, destructible vinyl, and tamper-proof security solutions.',
    image: 'https://cdn.magicpatterns.com/uploads/qT8CfHFWQ1qtv9oJGutAJQ/skanem_lead_pic_(1).jpg',
    size: 'large',
    href: '/products/tamper-evident-labels'
  }];
  return <section className="py-16 bg-white" data-id="element-301">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-302">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-10 gap-6" data-id="element-303">
          <div data-id="element-304">
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#0A1628] mb-4 tracking-tight" data-id="element-305">
              Shop by product type
            </h2>
            <p className="text-slate-500 text-lg" data-id="element-306">
              Browse our range or search for specific products.
            </p>
          </div>
          <a href="/products" className="hidden md:flex items-center px-6 py-3 bg-[#0052CC] text-white font-bold rounded-full hover:bg-[#0040A0] transition-colors text-base shadow-lg shadow-[#0052CC]/20" data-id="element-307">
            View all products
            <ArrowUpRight className="ml-2 h-5 w-5" data-id="element-308" />
          </a>
        </div>

        {/* Product Grid - Primary ecommerce entry */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 auto-rows-[300px]" data-id="element-309">
          {categories.map((category, index) => <motion.a key={index} href={category.href} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className={`group relative rounded-2xl overflow-hidden cursor-pointer ring-1 ring-slate-200 hover:ring-4 hover:ring-[#0052CC]/40 transition-all duration-300 shadow-lg hover:shadow-2xl ${category.size === 'large' ? 'md:col-span-2' : ''}`} data-id="element-310">
              <img src={category.image} alt={category.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-311" />

              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628] via-[#0A1628]/40 to-transparent" data-id="element-312" />

              <div className="absolute bottom-0 left-0 p-6 w-full" data-id="element-313">
                <div className="flex items-end justify-between gap-4" data-id="element-314">
                  <div data-id="element-315">
                    <h3 className="text-2xl md:text-3xl font-bold text-white mb-1.5 leading-tight" data-id="element-316">
                      {category.title}
                    </h3>
                    <p className="text-slate-300 text-sm leading-relaxed max-w-md" data-id="element-317">
                      {category.description}
                    </p>
                  </div>
                  <div className="flex-shrink-0 h-11 w-11 bg-[#0052CC] rounded-full flex items-center justify-center transform group-hover:scale-110 group-hover:bg-white transition-all duration-300 shadow-lg" data-id="element-318">
                    <ArrowUpRight className="h-5 w-5 text-white group-hover:text-[#0052CC] transition-colors" data-id="element-319" />
                  </div>
                </div>
              </div>
            </motion.a>)}
        </div>

        {/* Mobile CTA */}
        <div className="md:hidden mt-6" data-id="element-320">
          <a href="/products" className="flex items-center justify-center w-full py-4 bg-[#0052CC] text-white font-bold rounded-xl shadow-lg" data-id="element-321">
            Browse products
            <ArrowUpRight className="ml-2 h-5 w-5" data-id="element-322" />
          </a>
        </div>
      </div>
    </section>;
}